<div fxLayout="row" fxLayoutAlign="end end" style="width: 42vw;">
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
    <h2>
        <mat-icon style="color:#00BA34;font-size: 50px;">check_circle</mat-icon>
    </h2>
    <!-- <h3>Congratulations!</h3> -->
    <div fxLayout="column" fxLayoutAlign="center center">
        <label mat-dialog-title class="launchDialog">Your bot registeration is completed successfully</label>
        <!-- <p class="launch-bot-p">We will get back to you in 2-3 working days once your bot details are verified.</p> -->
    </div>
    <div fxLayoutAlign="center center">
        <button type="button" tooltip="Copied to clipboard" triggers="click" [matRippleCentered]="true"  #toolTip="bs-tooltip" matRipple
            (mouseleave)="toolTip.hide()" placement="top" class="resend-btn" ngxClipboard
            [cbContent]="copyURL">Copy Bot Link<mat-icon style="font-size: 15px;">
                content_copy</mat-icon>
        </button>
    </div>


</div>